//* Components imports
import { Form } from 'react-bootstrap';

//* Libraries imports
import { motion } from 'framer-motion';

// * Animations imports
import { formItemVariants } from '../animations';

type DescriptionFieldsProps = {
  register: any;
  errors: any;
};

export function DescriptionFields({ register, errors }: DescriptionFieldsProps) {
  return (
    <>
      <motion.div variants={formItemVariants} custom={6}>
        <Form.Group className="mb-4">
          <Form.Label htmlFor="descricaoField">Descrição dos Fatos</Form.Label>
          <Form.Control
            id="descricaoField"
            as="textarea"
            rows={4}
            placeholder="Descreva detalhadamente os fatos relacionados ao seu recurso..."
            title="Descrição dos fatos relacionados ao recurso"
            aria-label="Descrição dos fatos relacionados ao recurso"
            className={errors.description ? "is-invalid" : ""}
            {...register("description")}
          />
          {errors.description && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Form.Text className="text-danger">
                {errors.description.message}
              </Form.Text>
            </motion.div>
          )}
        </Form.Group>
      </motion.div>{" "}
      <motion.div variants={formItemVariants} custom={7}>
        <Form.Group className="mb-4">
          <Form.Label htmlFor="fundamentacaoField">
            Fundamentação do Pedido
          </Form.Label>
          <Form.Control
            id="fundamentacaoField"
            as="textarea"
            placeholder="Apresente os argumentos que fundamentam seu pedido de recurso..."
            title="Fundamentação do pedido de recurso"
            aria-label="Fundamentação do pedido de recurso"
            rows={4}
            className={errors.fundamentacao ? "is-invalid" : ""}
            {...register("fundamentacao")}
          />
          {errors.fundamentacao && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Form.Text className="text-danger">
                {errors.fundamentacao.message}
              </Form.Text>
            </motion.div>
          )}
        </Form.Group>{" "}
      </motion.div>
      <motion.div variants={formItemVariants} custom={8}>
        <Form.Group className="mb-4">
          <Form.Label htmlFor="pedidoField">Pedido</Form.Label>
          <Form.Control
            id="pedidoField"
            as="textarea"
            placeholder="Qual é o seu pedido? Ex: Anulação da questão, alteração de gabarito, etc."
            title="Pedido específico do recurso"
            aria-label="Pedido específico do recurso"
            rows={3}
            {...register("pedido_realizado")}
            className={errors.pedido_realizado ? "is-invalid" : ""}
          />
          {errors.pedido_realizado && (
            <motion.div
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Form.Text className="text-danger">
                {errors.pedido_realizado.message}
              </Form.Text>
            </motion.div>
          )}
        </Form.Group>
      </motion.div>
    </>
  );
}
